import axios from 'axios';
import _ from 'lodash';
import { helperGetApiHeaders, helperGetApiRoute } from 'helpers/ApiHelper';
import { concatToUrl } from 'helpers/ContentHelper';

const FETCH_FOOTER_UPSELL_COLLECTION = 'FETCH_FOOTER_UPSELL_COLLECTION';
const FETCH_FOOTER_UPSELL_COLLECTION_PANEL = 'FETCH_FOOTER_UPSELL_COLLECTION_PANEL';
export const SET_FOOTER_UPSELL_COLLECTION = 'SET_FOOTER_UPSELL_COLLECTION';

function setFooterUpsellCollection(collection) {
  return {
    type: SET_FOOTER_UPSELL_COLLECTION,
    payload: collection,
  };
}

function fetchFooterUpsellCollection(path, accessToken, deviceId) {
  const request = axios.get(
    concatToUrl(path, 'populated=false'),
    helperGetApiHeaders({ accessToken, deviceId }),
  );

  return {
    type: FETCH_FOOTER_UPSELL_COLLECTION,
    payload: request,
  };
}

function fetchFooterUpsellCollectionPanel(panel, accessToken, deviceId) {
  const { '@id': url } = panel;
  const request = axios.get(url, helperGetApiHeaders({ accessToken, deviceId }));
  return {
    type: FETCH_FOOTER_UPSELL_COLLECTION_PANEL,
    payload: request,
  };
}

export function fetchCollectionForFooterUpsell(pathKey, accessToken, deviceId) {
  return dispatch => {
    let collection;
    const path = helperGetApiRoute(pathKey);
    return dispatch(fetchFooterUpsellCollection(path, accessToken, deviceId)).then(result => {
      collection = _.get(result, 'payload.data.panels', {});
      const screenPanels = _.get(collection, 'member');
      if (!screenPanels) {
        return Promise.resolve();
      }
      return Promise.all(
        screenPanels.map((screenPanel, index) => {
          if (!screenPanel) return Promise.resolve();
          return dispatch(
            fetchFooterUpsellCollectionPanel(screenPanel, accessToken, deviceId),
          ).then(item => {
            const data = _.get(item, 'payload.data');
            _.set(collection, `member.${index}`, data);
            return Promise.resolve();
          });
        }),
      ).then(() => dispatch(setFooterUpsellCollection(collection)));
    });
  };
}
